import React from 'react';
import { DetailAttestation } from '~/components/Patient';
import { enumValue } from '~/util';

interface NotePCMRiskProps {
    entity: NoteType | ReminderType;
    gap?: null | RiskGapType;
    patientId: number;
}
export function NotePCMRisk({ entity, gap = null, patientId }: NotePCMRiskProps) {
    if (entity.risk_gap && gap) {
        return (
            <DetailAttestation
                riskGap={gap}
                patientId={patientId}
                className="d-inline-block fw-bold link-text"
            >
                {entity.risk_gap.is_added ? entity.risk_gap.code : entity.risk_gap.icd?.code}
            </DetailAttestation>
        );
    }
    if (entity?.risk_gap) {
        return (
            <span className="fw-bold">
                {entity.risk_gap.is_added ? entity.risk_gap.code : entity.risk_gap.icd?.code}
            </span>
        );
    }
    if (entity?.notes) {
        const note = entity.notes.find(
            (x) => x.action === enumValue(['note', 'action', 'Gap removed'])
        );
        if (note?.metadata?.code) {
            return <span className="fw-bold">{note.metadata.code}</span>;
        }
    }
    return <span className="fw-bold">{(entity as NoteType).metadata?.code}</span>;
}
